import styled from '@emotion/styled';
import type { MicrositeVideoData } from '~/model';
import MicrositeVideo from '~/components/MicrositeVideo';

const Section = styled.section`
	padding: 3rem 1.5rem 4rem;
`;

const Title = styled.h2`
	font-size: 2.5rem;
	font-weight: 500;
	text-align: center;
	margin-bottom: 1.5rem;
`;

const Player = styled.div`
	max-width: 64rem;
	margin: 0 auto;
	aspect-ratio: 16 / 9;
`;

export default function VideoBlockEpsilon({ title, video }: { title: string; video: MicrositeVideoData }) {
	return (
		<Section id="videos">
			<Title>{title}</Title>
			<Player>
				<MicrositeVideo video={video} />
			</Player>
		</Section>
	);
}
